class LandingPage extends DrupalBehavior {

  onContent(context) {
    super.onReady();

    new autoComplete({
      selector: '.form-item-keywords input.form-text',
      menuClass: 'advanced-search-filter',
      minChars: 2,
      delay: 50,
      source: function(term, response){
        $.getJSON('/provider/autocomplete', {
          keywords: term
        },
        function(data) {
          var providers = [{title: 'Providers', heading: true}, ...data.providers];
          var specialties = [{title: 'Specialties', heading: true}, ...data.specialties];
          var clinicalInterests = [{title: 'Clinical Interests', heading: true}, ...data.clinicalInterests];
          var locations = [{title: 'Locations', heading: true}, ...data.locations];
          var allResults = () => {
            let all = [];
            if (!!providers.filter(item => item.title !== 'Providers').length) all = providers;
            if (!!specialties.filter(item => item.title !== 'Specialties').length) all = [...all, ...specialties];
            if (!!clinicalInterests.filter(item => item.title !== 'Clinical Interests').length) all = [...all, ...clinicalInterests];
            if (!!locations.filter(item => item.title !== 'Locations').length) all = [...all, ...locations];

            return all;
          }
          response(allResults());
        });
      },
      onSelect: function(e, term, item){
        let form = $('form.guthrie-fap-landing-page-form');
        if (item.getAttribute('data-taxonomy') === 'specialties') {
          window.location = `/provider?searching=1&specialties=${item.getAttribute('data-id')}`;
        } else if (item.getAttribute('data-taxonomy') === 'clinicalInterests') {
          window.location = `/provider?searching=1&clinical_interests=${item.getAttribute('data-id')}`;
        } else if (item.getAttribute('data-taxonomy') === 'locations') {
          window.location = `/provider?searching=1&locations=${item.getAttribute('data-id')}`;
        }
        else {
          form.submit();
        }
      },
      renderItem: function (item, search){
        if (item.heading === true) {
          return `<div class="autocomplete-heading" data-val="${item.title}">${item.title}</div>`;
        } else {
          search = search.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
          let re = new RegExp("(" + search.split(' ').join('|') + ")", "gi");
          let id = typeof item.id === 'undefined' ? item.title : item.id
          let taxonomy = typeof item.key === 'undefined' ? '' : item.key
          return `<div class="autocomplete-suggestion" data-taxonomy="${taxonomy}" data-id="${id}" data-val="${item.title}">${item.title.replace(re, "<b>$1</b>")}</div>`;
        }
      }
    });

    $('.fap-results .column-right .rating', context).each(function(){
      let ratingNumber = $(this).attr('data-rating');
      let ratingWidth = $(this).width();
      let ratingPercentage = Math.floor((ratingNumber / 5) * 100);
      $(this).css('width', `${ratingWidth * (ratingPercentage * .01)}px`);
    });

    if(window.location.pathname === '/providers' && window.location.search === '') {
      $('.site-wrap.fap-landing', context).addClass('no-search');

    }else {
      $('.site-wrap.fap-landing', context).addClass('search');
    }

    $('.fap-landing .provider-teaser .content-left .video-modal', context).each(function(){
      var iframe = $(this).find('iframe');
      var url = iframe.attr('src');
      if (url.includes("http://")) {
          iframe.attr('src', url.replace("http://", "https://"));
      }
    });

    enquire.register(this.settings.breakpoints['guthrie_theme_guthrie_theme.md_min'].query, {
      match: () => {
        $('.fap-landing.no-search .fap-results .column-left, .fap-landing .fap-form').css('top', 0);
        $('.fap-landing.no-search .fap-form').removeClass('open');
        $('.fap-landing.no-search .fap-results .column-left').removeClass('open');
      },
    });
    enquire.register(this.settings.breakpoints['guthrie_theme_guthrie_theme.sm_max'].query, {
      match: () => {
        $('.fap-landing.search .mobile-toggles .dark-blue-btn', context).on('click', function(event) {
          event.preventDefault();
          $('.fap-landing.search .fap-form').toggleClass('open');
        });
        $('.fap-landing.search .fap-form .mobile-header button.close', context).on('click', function(event) {
          event.preventDefault();
          $('.fap-landing .fap-form').removeClass('open');
        });
        $('.fap-landing.search .mobile-toggles .med-blue-btn', context).on('click', function(event) {
          event.preventDefault();
          $('.fap-landing.search .fap-results .column-left').toggleClass('open');
        });
        $('.fap-landing.search .fap-results .mobile-header button.close', context).on('click', function(event) {
          event.preventDefault();
          $('.fap-landing.search .fap-results .column-left').removeClass('open');
        });
        $('.fap-landing.search .fap-results .column-left, .fap-landing.search .fap-form').css('top', 77);
      },
    });

    const showTooltip = (e) => {
      e.parents('.offers-telemedicine').addClass('show');
    };
    const hideTooltip = (e) => {
      e.parents('.offers-telemedicine').removeClass('show');
    };

    $('.offers-telemedicine--label span')
      .mouseover(function () { showTooltip($(this)) })
      .mouseout(function () { hideTooltip($(this)) })
      .focusin(function () { showTooltip($(this)) })
      .focusout(function () { hideTooltip($(this)) })
  }

}

DrupalBehavior.register('guthrie_fap', 'landing-page', LandingPage);
